import {
  consultarUsuarioFvLoading,
  consultarUsuarioFvHasErrror,
  setConsultarUsuarioFv
} from "../actions/aFormularioVinculacion";
import { handleActions } from 'redux-actions'


//------------------------- Inician Reducers -------------------------

export const rFormularioVinculacion = handleActions(
  {
    [consultarUsuarioFvLoading]: (state) => ({ ...state,  usuarioFvLoading: true}),
    [consultarUsuarioFvHasErrror]: (state) => ({  ...state, usuarioFvHasErrror: true}),
    [setConsultarUsuarioFv]: (state, action) => ({ ...state, usuarioFv: action.payload, usuarioFvLoading: false, usuarioFvHasErrror:false  }),
  },
  {
    usuarioFvLoading: false,
    usuarioFvHasErrror: false,
    usuarioFv: null
  }
);


//------------------------- Terminan Reducers -------------------------
